import React from 'react'
import { iconsList } from './'
import styles from './Icon.module.css'

const sizes = {
  'small': 17,
  'default': 24,
  'medium': 35,
  'large': 46,
}

const SpecificIcon = props => {
  const list = {
    ...iconsList,
    ...props.list,
  }

  const IconComponent = list[props.name] || list[Icon.defaultProps.name]
  return <IconComponent {...props} />
}

const Icon = props => (
  <div className={`icon-el ${styles.base}`}>
    <SpecificIcon width={sizes[props.size]} height={sizes[props.size]} {...props} />
  </div>
)

Icon.defaultProps = {
  name: 'arrow-right',
  size: 'default',
}

export default Icon
